module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "page-social-links"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('clearfix', {
    attrs: {
      "biggest": true,
      "bootstrap": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "home-button home-media-button",
    on: {
      "click": function($event) {
        return this.window.open('https://twitter.com/0xCBEE', '_blank')
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "twitter",
      "scale": "5"
    }
  }), _c('br'), _vm._v(" "), _c('br'), _vm._v("\n          TWITTER\n        ")], 1)])], 1), _vm._v(" "), _c('clearfix', {
    attrs: {
      "biggest": true
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-44c9325e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/SocialLinks.vue
// module id = 1827
// module chunks = 1